
let HeaderNavDic = [
  {
    name: "首页",
    path: "/",
    children: [],
  },
  {
    name: "医院概况",
    path: "/yygk/home",
    children: [],
  },
  {
    name: "医疗特色",
    path: "/ylts/home",
    children: [
      {
        name: "科室介绍",
        path: "/ylts/home",
      },
      {
        name: "盛京名医",
        path: "/ylts/mingyi",
      },
      {
        name: "国家临床重点专科",
        path: "/ylts/zhuanke",
      },
      {
        name: "特色医疗中心",
        path: "/ylts/tese",
      },
      {
        name: "护理专业发展",
        path: "/ylts/huli",
      },
    ],
  },
  {
    name: "教学科研",
    path: "/jxky/home",
    children: [
      {
        name: "研究生教育",
        path: "/jxky/yanjiusheng",
      },
      {
        name: "毕业后医学教育",
        path: "/jxky/byhyxjy",
      },
      {
        name: "学术交流",
        path: "/jxky/xueshu",
      },
      {
        name: "承办杂志",
        path: "/jxky/zazhi",
      },
      {
        name: "科技创新平台",
        path: "/jxky/zdsys",
      },

      {
        name: "伦理委员会",
        path: "/jxky/llwyh",
      },

      {
        name: "药物临床试验机构",
        path: "/jxky/ywlcsyjg",
      },
      {
        name: "诚信建设",
        path: "/jxky/cxjs",
      },
    ],
  },
  {
    name: "盛京文化",
    path: "/sjwh",
    children: [
      {
        name: "百年历史",
        path: "/sjwh",
      },
      {
        name: "院标/办院理念/院训/院歌",
        path: "/sjwh/yuange",
      },
      // {
      //   name: "盛京医讯",
      //   path: "/sjwh/zhoukan",
      // },
      // {
      //   name: "盛京TV",
      //   path: "/sjwh/tv",
      // },
      {
        name: "盛京映像",
        path: "/sjwh/yingxiang",
      },
      // {
      //   name: "盛京医院的故事",
      //   path: "/sjwh/gushi",
      // },
    ]
  }
]
// 教学科研
let jxkyNavDic =
  [
    {
      name: "研究生教育",
      path: "/jxky/yanjiusheng",
    },
    {
      name: "毕业后医学教育",
      path: "/jxky/byhyxjy",
    },
    {
      name: "学术交流",
      path: "/jxky/xueshu",
    },

    {
      name: "承办杂志",
      path: "/jxky/zazhi",
    },
    {
      name: "科技创新平台",
      path: "/jxky/zdsys",
    },
    {
      name: "伦理委员会",
      path: "/jxky/llwyh",
    },
    {
      name: "药物临床试验机构",
      path: "/jxky/ywlcsyjg",
    },
    {
      name: "诚信建设",
      path: "/jxky/cxjs",
    },
  ]


export {
  HeaderNavDic,
  jxkyNavDic
};
